import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setLanguage, t } from "../i18n";
import styles from "./resetpassword.module.css";
import DarkModeToggle from "./DarkModeToggle";
import ErrorModal from "./ErrorModal";
import LogoEn from "../assets/logo_punchline_en.png";
import LogoZh from "../assets/logo_punchline_zh.png";

const ResetPassword = () => {
  const [languageState, setLanguageState] = useState(sessionStorage.getItem("language") || "en");
  const [email, setEmail] = useState("");
  const [gotToken, setGotToken] = useState(false);
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleResetRequest = (event) => {
    event.preventDefault();

    fetch(process.env.REACT_APP_API_PATH + "/auth/request-reset", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    })
      .then((res) => {
        if (res.ok) {
          setGotToken(true);
        } else {
          setErrorMessage("No account found with this email.");
          setShowModal(true);
        }
      })
      .catch(() => {
        setErrorMessage("An error occurred. Please try again.");
        setShowModal(true);
      });
  };

  const handleResetPassword = (event) => {
    event.preventDefault();

    fetch(process.env.REACT_APP_API_PATH + "/auth/reset-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    })
      .then((res) => {
        if (res.ok) {
          navigate("/");
        } else {
          setErrorMessage("Invalid token or password reset failed.");
          setShowModal(true);
        }
      })
      .catch(() => {
        setErrorMessage("An error occurred. Please try again.");
        setShowModal(true);
      });
  };

  const changeLanguage = (language) => {
    setLanguage(language);
    setLanguageState(language);
  };

  const getLogo = () => {
    if (languageState === "en") return LogoEn;
    else if (languageState === "zh") return LogoZh;
  };

<form onSubmit={handleResetRequest} className={styles.form} autoComplete="off">
  <div className={styles.inputContainer}>
    <input
      type="email"
      placeholder=" "
      className={styles.input}
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      autoComplete="off"
    />
    <label className={styles.label}>{t("email")}</label>
  </div>
  <button type="submit" className={styles.resetButton}>{t("send_reset_link")}</button>
</form>
  return (
    <div className={styles.container}>
      {/* Error Modal */}
      <ErrorModal show={showModal} onClose={() => setShowModal(false)} title={t("reset_password_error")} message={errorMessage} />

      {/* Left Side - Logo Placeholder */}
      <div className={styles.logoContainer}>
        <img src={getLogo()} alt="Logo" className={styles.logoText} />
      </div>

      {/* Right Side - Reset Password Box */}
      <div className={styles.resetBox}>
        <h1 className={styles.title}>{t("reset_password")}</h1>

        {!gotToken ? (
          <form onSubmit={handleResetRequest} className={styles.form}>
            <div className={styles.inputContainer}>
              <input type="email" placeholder=" " className={styles.input} value={email} onChange={(e) => setEmail(e.target.value)} />
              <label className={styles.label}>{t("email")}</label>
            </div>
            <button type="submit" className={styles.resetButton}>{t("send_reset_link")}</button>
          </form>
        ) : (
          <form onSubmit={handleResetPassword} className={styles.form}>
            <div className={styles.inputContainer}>
              <input type="text" placeholder=" " className={styles.input} value={token} onChange={(e) => setToken(e.target.value)} />
              <label className={styles.label}>{t("reset_token")}</label>
            </div>
            <div className={styles.inputContainer}>
              <input type="password" placeholder=" " className={styles.input} value={password} onChange={(e) => setPassword(e.target.value)} />
              <label className={styles.label}>{t("new_password")}</label>
            </div>
            <button type="submit" className={styles.resetButton}>{t("reset_password")}</button>
          </form>
        )}

        <div className={styles.linkContainer}>
          <Link to="/" className={styles.link}>{t("login")}</Link>
        </div>
        <div className={styles.languageSwitcher}>
          <span onClick={() => changeLanguage('en')} className={styles.languageText}>English</span>
          <span onClick={() => changeLanguage('zh')} className={styles.languageText}>中文</span>
        </div>
      </div>
      <DarkModeToggle />
    </div>
  );
};

export default ResetPassword;
